module.exports = "<textarea class=\"textarea js-input\" {{#if maxLength}}maxlength=\"{{maxLength}}\"{{/if}}></textarea>";